import { Check, Eye } from "phosphor-react";
import React from "react";
import useNavigation from "~/admin/hooks/useNavigation";
import Badge from "~/admin/components/Badge";
import Card from "~/admin/components/Card";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import Pagination from "~/admin/components/Pagination";
import moment from "moment";

export default function BlockedListTab({ blockedUsers, onPaginate }) {
  const { navigate } = useNavigation();

  return (
    <>
      {blockedUsers.items?.length > 0 ? (
        <Card>
          <Table>
            <thead>
              <Tr>
                <Th>Nom</Th>
                <Th>Nombre de signalement</Th>
                <Th>Dernier signalement</Th>
                <Th>Type</Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {blockedUsers.items.map((blockedUser) => {
                return (
                  <Tr key={blockedUser.id}>
                    <Td>{blockedUser.name}</Td>
                    <Td className="text-danger">{blockedUser.nbReports}</Td>
                    <Td>
                      {moment(blockedUser.lastReport).format("DD/MM/YYYY")}
                    </Td>
                    <Td>
                      {blockedUser.type === "influencer" ? (
                        <Badge color="light">Influenceur</Badge>
                      ) : (
                        <Badge color="info">Entreprise</Badge>
                      )}
                    </Td>
                    <Td>
                      <Eye
                        className="cursor-pointer hover:text-gray-400"
                        size={24}
                        onClick={() => navigate(`reports/${blockedUser.id}`)}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {blockedUsers.items && (
            <div className="pt-4 text-center">
              <Pagination
                lastPage={blockedUsers.lastPage}
                currentPage={blockedUsers.currentPage}
                onPaginate={onPaginate}
              />
            </div>
          )}
        </Card>
      ) : (
        <div className="px-4 py-2 bg-green-300 text-green-700 w-fit rounded-md mx-auto flex space-x-4 items-center">
          <div className="rounded-full border w-fit border-green-700 h-fit">
            <Check />
          </div>
          <div>Il n'y a aucun utilisateur bloqué !</div>
        </div>
      )}
    </>
  );
}
